import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'


function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getUserAdvancedSettingsData() {
	return http_agent.post(config.services + 'userAdvancedSettings/get')
		.send({})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function saveUserAdvancedSettingsData(setting, value) {
	return http_agent.post(config.services + 'userAdvancedSettings/save')
		.send({
			[setting]: value,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

export default {
	getUserAdvancedSettingsData,
	saveUserAdvancedSettingsData,
}
